// Turks (tr-TR), golf2App: zelfde vorm als golf2App.nl.ts. Wat ontbreekt valt terug op het
// Nederlands (nooit een rauwe sleutel op het scherm).
export const appChecklistTr = {
    title: 'Kontrol listesi',
    hint: 'Yanına ne alınacak? Tablet listeyi çağrının yanında gösterir, çocuğun da işaretler.',
    empty: 'Listede henüz bir şey yok. Aşağıdan seç ya da kendin ekle.',
    suggestions: 'Öneriler',
    suggestionAdd: 'Ekle: {label}',
    addAll: 'Hepsini ekle',
    newLabel: 'Başka bir şey',
    newPlaceholder: 'Örneğin: Yüzücü gözlüğü',
    add: 'Ekle',
    labelRequired: 'Bir kelime yaz.',
    labelTooLong: 'En fazla 40 karakter.',
    max: 'Liste başına en fazla 12 şey.',
    itemPicto: 'Resim: {label}',
    up: 'Yukarı taşı: {label}',
    down: 'Aşağı taşı: {label}',
    remove: 'Kaldır: {label}',
    previewTitle: 'Çağrının yanında',
    sheetTitle: 'Çantaya girecekler',
    sheetProgress: '{done}/{total} hazır',
    sheetAllDone: 'Her şey çantada',
    sheetNone: 'Henüz hiçbir şey işaretlenmedi',
    sheetItemDone: '{label}: çantada',
    sheetItemOpen: '{label}: henüz değil',
    items: {
        'swim-trunks': 'Deniz şortu',
        swimsuit: 'Mayo',
        towel: 'Havlu',
        underwear: 'İç çamaşırı',
        socks: 'Çorap',
        shampoo: 'Şampuan',
        slippers: 'Terlik',
        'football-boots': 'Krampon',
        'shin-guards': 'Tekmelik',
        'water-bottle': 'Su şişesi',
        quran: 'Kuran',
        backpack: 'Çanta',
        headscarf: 'Başörtüsü',
        'prayer-cap': 'Takke',
        coat: 'Mont',
        shoes: 'Ayakkabı',
        lunch: 'Beslenme',
        fruit: 'Meyve',
        homework: 'Ödev',
        reading: 'Okuma kitabı',
        'music-lesson': 'Müzik kitabı',
        'get-dressed': 'Spor kıyafeti',
    },
};
export const appActivitiesTr = {
    section: 'Düzenli etkinlik',
    toggle: 'Bu düzenli bir etkinlik',
    toggleHint: 'Okul, cami dersi ya da futbol gibi: aşağıda seçtiğin tatiller ve aralar dışında her hafta yapılır.',
    needsRecurrence: 'Önce bir tekrar seç: düzenli etkinlik her hafta tekrarlanır.',
    followSchool: 'Okul tatillerine uyar',
    followSchoolHint: '{region} bölgesinin okul tatillerinde bu etkinlik yapılmaz.',
    followSchoolNoRegion: 'Aşağıdaki Ayarlar düğmesinden okul tatili bölgenizi seçin. Bu bölge tüm aile için geçerlidir.',
    regions: { noord: 'Kuzey', midden: 'Orta', zuid: 'Güney' },
    pauses: 'Aralar',
    pausesHint: 'Bu etkinliğin durduğu dönemler. Bir arayı başka etkinliklerle paylaşabilirsin.',
    noPauses: 'Henüz ara yok.',
    newPause: 'Yeni ara',
    pauseName: 'Ad',
    pauseNamePlaceholder: 'Yaz arası',
    pauseFrom: 'Başlangıç',
    pauseTo: 'Son gün',
    pauseAdd: 'Ara ekle',
    pauseCancel: 'Vazgeç',
    pauseNameRequired: 'Araya bir ad ver.',
    pauseRangeInvalid: 'Başlangıç tarihinde ya da sonrasında, bir yıl içinde bir bitiş tarihi seç.',
    pausePresets: {
        zomerstop: 'Yaz arası',
        winterstop: 'Kış arası',
        zomervakantie: 'Yaz tatili',
    },
    sharedWith: 'Şunlarda da: {names}',
    saved: 'Düzenli etkinlik kaydedildi',
    saveFailed: 'Etkinlik kaydedildi ama aralar kaydedilmedi. Tekrar dene.',
    barLabel: '{title}, {range}',
    schoolHoliday: 'Okul tatili',
    pause: 'Ara',
    stops: 'Duruyor: {names}',
    stopsNone: 'O zaman duran düzenli etkinlik yok.',
    sheetSchoolHint: 'Okul tatilleri, bölgene göre Hollanda hükümetinden (Rijksoverheid) gelir. Tatillere uyan düzenli bir etkinlik o zaman yapılmaz.',
    sheetPauseHint: 'Bu dönemde aşağıdaki etkinlikler yapılmaz: çağrı yok, yolculuk yok.',
    editPause: 'Arayı değiştir',
    deletePause: 'Arayı kaldır',
    deletePauseConfirm: 'Emin misin? Etkinlikler bu dönemde normal şekilde devam eder.',
    pauseDeleted: '"{name}" arası kaldırıldı',
    pauseUpdated: '"{name}" arası kaydedildi',
    fixedChip: 'Düzenli etkinlik',
};
//# sourceMappingURL=golf2App.tr.js.map